// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8720) return "static/chunks/8720-69a1cac12f25c5d6.js";
	if (chunkId === 6522) return "static/chunks/6522-b8c846da11680d6f.js";
	if (chunkId === 6489) return "static/chunks/6489-a8dc7038d3e8cf33.js";
	if (chunkId === 2377) return "static/chunks/2377-b62a52e86c4bda9b.js";
	if (chunkId === 3411) return "static/chunks/3411-07e4c4c7ee3685a0.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"564":"21831b81ea365c18","1697":"0597ca5474847064","1935":"263809a1542eae42","5544":"1100af16a53def1b","6146":"5454808c077b7800"}[chunkId] + ".js";
};